import BillingProviderCustomer from '@/datatypes/billing/provider-customer';

export default class BillingProviderInvoice {
  public id: string;
  public customerId: string;
  public customer: BillingProviderCustomer = new BillingProviderCustomer({});
  public status: string;
  public subscriptionId: string;
  public dueDate: string;
  public amountDue: number;
  public created: string;

  constructor(options) {
    this.id = options.id;
    this.customerId = options.customerId;
    if (options.customer) {
      this.customer = new BillingProviderCustomer(options.customer);
    }
    this.status = options.status;
    this.subscriptionId = options.subscriptionId;
    this.dueDate = options.dueDate;
    this.amountDue = options.amountDue;
    this.created = options.created;
  }
}
